'use strict';

/* globals config */

require([config.relative_path + '/plugins/nodebb-plugin-lessons/static/vendor/vue.js'], function (Vue) {
	Vue.component('question-edit-answers', {
		props: ['question', 'answerTypes', 'initData'],
		data: function () {
			return {
				addType: this.answerTypes[0].type,
			};
		},
		methods: {
			addAnswer: function () {
				this.question.answers.push({
					type: this.addType,
					content: '',
				});
			},
			removeAnswer: function (answer) {
				var index = this.question.answers.indexOf(answer);

				if (index > -1) {
					this.question.answers.splice(index, 1);
				}
			},
		},
		template:
		'<div>' +
			'<h5 class="mb-2">Answers</h5>' +
			'<div class="row mb-3">' +
				'<div class="col-md-4">' +
					'<select class="form-control" v-model="addType">' +
						'<option v-for="answerType in answerTypes" :value="answerType.type">{{answerType.name}}</option>' +
					'</select>' +
				'</div>' +
				'<div class="col-md-8">' +
					'<button type="button" class="btn btn-primary" v-on:click="addAnswer()">{{initData.translations.addAnswer}}</button>' +
				'</div>' +
			'</div>' +
			'<div class="list-group answers-editor">' +
				'<answer-edit v-for="(answer, index) in question.answers" :init-data="initData" :index="index" :answer="answer" :remove="removeAnswer" :answer-types="answerTypes"></answer-edit>' +
			'</div>' +
		'</div>',
	});
});
